import { financialService } from "services/underwriting/financial.service";

import { financialConstants } from "./financial.constants";

export const financialActions = {
	addBankBalance,
	addFinancial,
	deleteBankBalance,
	deleteFinancial,
	editBankBalance,
	editFinancial,
	getBankBalances,
	getFinancials,
};

function getFinancials(applicationId) {
	return dispatch => {
		dispatch(request());
		return financialService.getFinancials(applicationId).then(
			result => dispatch(success(result)),
			error => dispatch(failure(error)),
		);
	};
	function request() {
		return { type: financialConstants.GET_FINANCIALS_REQUEST };
	}
	function success(financials) {
		return { type: financialConstants.GET_FINANCIALS_SUCCESS, financials };
	}
	function failure(error) {
		return { type: financialConstants.GET_FINANCIALS_ERROR, error };
	}
}

function getBankBalances(applicationId) {
	return dispatch => {
		dispatch(request());
		return financialService.getBankBalances(applicationId).then(
			result => dispatch(success(result)),
			error => dispatch(failure(error)),
		);
	};
	function request() {
		return { type: financialConstants.GET_BANK_BALANCES_REQUEST };
	}
	function success(bankBalances) {
		return {
			type: financialConstants.GET_BANK_BALANCES_SUCCESS,
			bankBalances,
		};
	}
	function failure(error) {
		return { type: financialConstants.GET_BANK_BALANCES_ERROR, error };
	}
}

function editBankBalance(bankBalanceModel) {
	return dispatch => {
		dispatch(request());
		return financialService.editBankBalance(bankBalanceModel).then(
			result => {
				dispatch(success(result));
				return Promise.resolve(result);
			},
			error => {
				dispatch(failure(error));
				return Promise.reject(error);
			},
		);
	};
	function request() {
		return { type: financialConstants.EDIT_BANK_BALANCE_REQUEST };
	}
	function success(editedBankBalance) {
		return {
			type: financialConstants.EDIT_BANK_BALANCE_SUCCESS,
			editedBankBalance,
		};
	}
	function failure(error) {
		return { type: financialConstants.EDIT_BANK_BALANCE_ERROR, error };
	}
}

function addBankBalance(bankBalanceModel, applicationId) {
	return dispatch => {
		dispatch(request());
		return financialService
			.addBankBalance({ ...bankBalanceModel, applicationId })
			.then(
				result => {
					dispatch(success(result));
					return Promise.resolve(result);
				},
				error => {
					dispatch(failure(error));
					return Promise.reject(error);
				},
			);
	};
	function request() {
		return { type: financialConstants.ADD_BANK_BALANCE_REQUEST };
	}
	function success(addedBankBalance) {
		return {
			type: financialConstants.ADD_BANK_BALANCE_SUCCESS,
			addedBankBalance,
		};
	}
	function failure(error) {
		return { type: financialConstants.ADD_BANK_BALANCE_ERROR, error };
	}
}

function editFinancial(financial) {
	return dispatch => {
		dispatch(request());
		return financialService.editFinancial(financial).then(
			result => {
				dispatch(success(result));
				return Promise.resolve(result);
			},
			error => {
				dispatch(failure(error));
				return Promise.reject(error);
			},
		);
	};
	function request() {
		return { type: financialConstants.EDIT_FINANCIAL_REQUEST };
	}
	function success(editedFinancial) {
		return {
			type: financialConstants.EDIT_FINANCIAL_SUCCESS,
			editedFinancial,
		};
	}
	function failure(error) {
		return { type: financialConstants.EDIT_FINANCIAL_ERROR, error };
	}
}

function addFinancial(financial, applicationId) {
	return dispatch => {
		dispatch(request());
		return financialService
			.addFinancial({ ...financial, applicationId })
			.then(
				result => {
					dispatch(success(result));
					return Promise.resolve(result);
				},
				error => {
					dispatch(failure(error));
					return Promise.reject(error);
				},
			);
	};
	function request() {
		return { type: financialConstants.ADD_FINANCIAL_REQUEST };
	}
	function success(addedFinancial) {
		return {
			type: financialConstants.ADD_FINANCIAL_SUCCESS,
			addedFinancial,
		};
	}
	function failure(error) {
		return { type: financialConstants.ADD_FINANCIAL_ERROR, error };
	}
}

function deleteFinancial(id) {
	return dispatch => {
		dispatch(request());

		return financialService.deleteFinancial(id).then(
			result => {
				dispatch(success(result));
				return Promise.resolve(result);
			},
			error => {
				dispatch(failure(error));
				return Promise.reject(error);
			},
		);
	};
	function request() {
		return { type: financialConstants.DELETE_FINANCIAL_REQUEST };
	}
	function success() {
		return {
			type: financialConstants.DELETE_FINANCIAL_SUCCESS,
		};
	}
	function failure(error) {
		return { type: financialConstants.DELETE_FINANCIAL_ERROR, error };
	}
}

function deleteBankBalance(id) {
	return dispatch => {
		dispatch(request());

		return financialService.deleteBankBalance(id).then(
			result => {
				dispatch(success(result));
				return Promise.resolve(result);
			},
			error => {
				dispatch(failure(error));
				return Promise.reject(error);
			},
		);
	};
	function request() {
		return { type: financialConstants.DELETE_FINANCIAL_REQUEST };
	}
	function success() {
		return {
			type: financialConstants.DELETE_FINANCIAL_SUCCESS,
		};
	}
	function failure(error) {
		return { type: financialConstants.DELETE_FINANCIAL_ERROR, error };
	}
}
